module.exports = {
  apiHost: "https://api.odesouthbank.sensoreal.app",
  assetsHost: "https://assets.odesouthbank.sensoreal.app",
  brandName: "",
  header: {
    text: { en: "Your Ode Southbank Selections" },
    logo:
      "https://assets.odesouthbank.sensoreal.app/misc/logo_stacked_orange_v1.png",
    companyLogo: "",
    color: "#ff540e",
  },
  langs: [{ code: "en", dir: "ltr" }],
  style: {
    backgroundColor: "#f1f0e1",
    primaryColor: "rgb(38, 38, 38)",
    textColor: "#ff540e",
    font: "HelveticaNow",
  },
  contact: {
    website: "",
    address: "",
    phone: "",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  },
  footerLogo:
    "https://static-mbh.sgp1.cdn.digitaloceanspaces.com/ode-southbank-edm/CEDA_Logo_mono.png?2",
  fields: [
    "houseDesign",
    "depth",
    "beds",
    "baths",
    "cars",
    "propertySize",
    "frontage",
  ],

  labels: {
    dwellingLabel: { en: "Apartment Type" },
    dwellingDesign: { en: "Collection" },
    dwellingSize: { en: "Internal Area" },
    propertyLabel: { en: "Unit No." },
    propertySize: { en: "Total Area" },
    frontage: { en: "Internal Area" },
    frontageSuffix: { en: "m<sup>2</sup>" },
    depth: { en: "External Area" },
    depthSuffix: { en: "m<sup>2</sup>" },
    viewLabel: { en: "Orientation" },
  },
};
